import './modules/_maps';
import brandsSlider from './sliders/brandsSlider/brandsSlider';
import partnersSlider from './sliders/partnersSlider/partnersSlider';

document.addEventListener('DOMContentLoaded', () => {

  const brandsSliderWrapper = Array.prototype.slice.call(document.querySelectorAll('.js-brands-slider-wrapper'));
  if (brandsSliderWrapper.length) {
    brandsSliderWrapper.forEach(el => {
      brandsSlider(el);
    })
  }

  const partnersSliderWrapper = Array.prototype.slice.call(document.querySelectorAll('.js-partners-slider-wrapper'));
  if (partnersSliderWrapper.length) {
    partnersSliderWrapper.forEach(el => {
      partnersSlider(el);
    });
  }
});
